module.exports = __webpack_public_path__ + "img/bindDoctorbg.9f758061.png";